var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingQiwaAddress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54167 3.75033C3.54167 2.59973 4.47441 1.66699 5.625 1.66699H13.9583C15.1089 1.66699 16.0417 2.59973 16.0417 3.75033V16.2503C16.617 16.2503 17.0833 16.7167 17.0833 17.292C17.0833 17.8673 16.617 18.3337 16.0417 18.3337H12.7431C12.2636 18.3337 11.875 17.945 11.875 17.4656V15.2087C11.875 14.6334 11.4086 14.167 10.8333 14.167H8.75C8.1747 14.167 7.70833 14.6334 7.70833 15.2087V17.4656C7.70833 17.945 7.31969 18.3337 6.84028 18.3337H3.54167C2.96637 18.3337 2.5 17.8673 2.5 17.292C2.5 16.7167 2.96637 16.2503 3.54167 16.2503V3.75033ZM6.66667 4.79199H8.75V6.87533H6.66667V4.79199ZM8.75 8.95866H6.66667V11.042H8.75V8.95866ZM10.8333 4.79199H12.9167V6.87533H10.8333V4.79199ZM12.9167 8.95866H10.8333V11.042H12.9167V8.95866Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingQiwaAddress);
export default __webpack_public_path__ + "static/media/onboarding-qiwa-address.456c5917714b9f12da49c73e5dfc521b.svg";
export { ForwardRef as ReactComponent };